import script from "./Cities.vue?vue&type=script&lang=ts&setup=true"
export * from "./Cities.vue?vue&type=script&lang=ts&setup=true"

import "./Cities.vue?vue&type=style&index=0&id=2f9b41f4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f9b41f4"]])

export default __exports__